/* eslint-disable react/display-name */
import React from 'react';
import { AdminLayout } from 'ui/components/layouts';
import { Tab, TabList, TabPanel, Tabs, Title } from 'ui/components/styled';
import CompanyBranding from './CompanyBranding';
import EmailTemplates from './EmailTemplates';

export default function Branding() {
  const [tabIndex, setTabIndex] = React.useState(0);
  return (
    <AdminLayout>
      <Title variant="dark" mx="m" mb="l">
        Branding
      </Title>
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          <Tab>Company Infos</Tab>
          <Tab>Email settings</Tab>
        </TabList>
        <TabPanel>
          <CompanyBranding />
        </TabPanel>
        <TabPanel>
          <EmailTemplates />
        </TabPanel>
      </Tabs>
    </AdminLayout>
  );
}
